import React , {useState , useEffect} from 'react'
import CloseOutlinedIcon from "@material-ui/icons/CloseOutlined";
import RmOnboarderTable from '../../AppComponent/RmOnboarderTable';
import{setRmOnboarderdatas} from "../../../Redux/Slice"
import { useDispatch } from 'react-redux';
export const RmOnboarderpopup = (props) => {
    const {setshow , data} = props;
    const dispatch = useDispatch()
      const [dtpageindex, setdtPageindex] = useState(1);
  const [pagedData, setPagedData] = useState([]);
  const pageSize = 20;

  const capitalizeFirstLetter = (Letter) => {
    return Letter.charAt(0).toUpperCase() + Letter.slice(1);
  };


  useEffect(() => {
    const start = (dtpageindex - 1) * pageSize;
    const end = start + pageSize;
    setPagedData(data.slice(start, end));
  }, [dtpageindex, data]);

  

      const columns = [
    {
      Header:"Employee",
      accessor: "",

      Cell: (row) => {
        return (
          <>
            {row.row.original.employee	 != undefined &&
              row.row.original.employee	 != null ? (
              <span>
                {capitalizeFirstLetter(row.row.original.employee	)}


              </span>
            ) : (
              <span>{"--"}</span>
            )}
          </>
        );
      },
    },

  
         {
          Header: "Client",
          accessor: "",
          Cell: (row) => {
            const [showTooltip, setShowTooltip] = useState(false);
        
            return (
              <>
                {row.row.original.client != null &&
                row.row.original.client != undefined &&
                row.row.original.client != "" &&
                row.row.original.client != undefined ? (
                  <div className="UserName"
                    onMouseEnter={() => setShowTooltip(true)}
                    onMouseLeave={() => setShowTooltip(false)}
                    style={{ position: 'relative' }} 
                  >
                    <span>
                      {row.row.original.client.length > 30 ? (
                        <>
                          {row.row.original.client.slice(0, 30)}...
                        </>
                      ) : (
                        <>{row.row.original.client}</>
                      )}
                    </span>
        
                    {showTooltip && (
                      <div className="custom-tooltip">
                        {row.row.original.client}
                      </div>
                    )}
                  </div>
                ) : (
                  <div className="UserName">
                    <span>---</span>
                  </div>
                )}
              </>
            );
          },
        },     

     {
      Header:"Onboarder Name",
      accessor: "",

      Cell: (row) => {
        return (
          <>
            {row.row.original.onboarder			 != undefined &&
              row.row.original.onboarder			 != null ? (
              <span>
                {capitalizeFirstLetter(row.row.original.onboarder			)}


              </span>
            ) : (
              <span>{"--"}</span>
            )}
          </>
        );
      },
    },



     {
      Header:"Pending Duration",
      accessor: "",

      Cell: (row) => {
        return (
          <>
            {row.row.original.days				 != undefined &&
              row.row.original.days				 != null ? (
              <span>
                {row.row.original.days}


              </span>
            ) : (
              <span>{"--"}</span>
            )}
          </>
        );
      },
    },



      ];

  const handleNext = (next) => {
    setdtPageindex(next + 1);
  };

  const GotoEnteredPage = (gotopage) => {
    setdtPageindex(gotopage)
  }

  const handlePrevious = (previous) => {
    if (previous != 0) {
      setdtPageindex(previous);

    }
  };
    const pagesize = (arg) => {
  };

  const pageindex = (arg) => {
    setdtPageindex(arg);
  };

  

  return (
    <>

  <div className="RoleCreatePopup">
        <div className="BeforePopUp">
          <div className="RolePopups" style={{
            width: "89%",
             height: "89%",
          }}>
            <div className="asds" style={{background:"#2c305c12",height:"100%"}}>
              <div class="ModalHeader" style={{height:"fit-content"}}>
                  <span className="UserCreate">{`Kyc Pending  - ${data.length}`} 
                  
                  
                  {/* <span style={{padding:"0px 42px"}}>{`Total count - ${data.length}`}</span> */}
                  </span>

                <div className="CloseIcon"onClick={()=>{
                  dispatch(setRmOnboarderdatas(true))
                    setshow(false);

                }} >
                  <CloseOutlinedIcon   />
                </div>
                </div>

                <div classname="RMTable" style={{padding:"13px 11px", height:"100%",overflowY:"auto",
                  overflowX:"hidden",
                  maxHeight:"651px"
                }}>

                    <RmOnboarderTable 
                data={pagedData}
                     columns={columns}
                          onPrevious={handlePrevious}
              onNextpage={handleNext}
              GotoEnteredPage={GotoEnteredPage}
                      pagesize={pagesize}
              dtpagesize={20}
                dtpageindex={dtpageindex}  // Ensure this is passed correctly

              pageindex={pageindex}
  datacount={data.length} // or actual total count from API

                totalItems={data.length} // or actual total count from API


                     />
                </div>
                </div>
                </div>
                </div>
                </div>
    </>
  )
}
